import React from 'react';
import { RouteProp } from '@react-navigation/native';
import { ProfilesTabParamList } from '../../../../../utils/appNavigationNames';
import ClientActivityHistoryTable from './ClientActivityHistoryTable';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';

export type ClientActivityHistoryScreenOwnProps = {};

export type ClientActivityHistoryScreenProps = ClientActivityHistoryScreenOwnProps & {
    route: RouteProp<ProfilesTabParamList, 'client-activity-history'>;
};

const ClientActivityHistoryScreen: React.FC<ClientActivityHistoryScreenProps> = (props) => {
    return (
        <MainContentContainer flex={1}>
            <ClientActivityHistoryTable clientRecordId={props.route.params.clientRecordId} />
        </MainContentContainer>
    );
};

export default React.memo(ClientActivityHistoryScreen);
